import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const visitorApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createVisitor: builder.mutation({
      query: body => ({
        url: 'visitor/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Visitor'],
    }),
    updateVisitor: builder.mutation({
      query: ({uuid, ...body}) => ({
        url: `visitor/${uuid}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Visitor'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useCreateVisitorMutation,
  useUpdateVisitorMutation,
} = visitorApi;
